import {
  RECEIPT_CONFIGURATION_ADD_REQUEST,
  RECEIPT_CONFIGURATION_ADD_REQUEST_SUCCESS,
  RECEIPT_CONFIGURATION_ADD_REQUEST_FAILURE,
  RECEIPT_CONFIGURATION_FETCH_REQUEST,
  RECEIPT_CONFIGURATION_FETCH_REQUEST_SUCCESS,
  RECEIPT_CONFIGURATION_FETCH_REQUEST_FAILURE,
  RECEIPT_CONFIGURATION_UPDATE_REQUEST,
  RECEIPT_CONFIGURATION_UPDATE_REQUEST_SUCCESS,
  RECEIPT_CONFIGURATION_UPDATE_REQUEST_FAILURE,
  RECEIPT_CONFIGURATION_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

const receiptConfigurationReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case RECEIPT_CONFIGURATION_ADD_REQUEST:
    case RECEIPT_CONFIGURATION_FETCH_REQUEST:
    case RECEIPT_CONFIGURATION_UPDATE_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });
    case RECEIPT_CONFIGURATION_ADD_REQUEST_SUCCESS:
    case RECEIPT_CONFIGURATION_FETCH_REQUEST_SUCCESS:
    case RECEIPT_CONFIGURATION_UPDATE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case RECEIPT_CONFIGURATION_ADD_REQUEST_FAILURE:
    case RECEIPT_CONFIGURATION_FETCH_REQUEST_FAILURE:
    case RECEIPT_CONFIGURATION_UPDATE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });
    case RECEIPT_CONFIGURATION_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });
    default:
      return state;
  }
};

export default receiptConfigurationReducer;
